import { Injectable } from '@angular/core';
import { CanActivateChild, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/auth/authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private logger: NGXLogger,
    private router: Router,
    private authenticationService: AuthenticationService,
    private deviceService: DeviceDetectorService,
    private snack: MatSnackBar
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const currentUser = this.authenticationService.currentUser;
    var role = this.authenticationService.currentRole;
    let urlConvert = state.url ? state.url.split('?')[0] : '';

    if (currentUser) {
      if (role && role.includes(urlConvert)) {
        return true;
      }
      this.logger.info('User không có quyền:', urlConvert);
      this.router.navigate(['/404'], {
        queryParams: {
          error: '403',
          accessUrl: urlConvert,
        },
      });
      return false;
    }
    this.logger.debug('Yêu cầu user đăng nhập!');
    let url = state.url;
    if (url.includes('fbclid'))
      url = url.slice(0, state.url.indexOf('fbclid') - 1);
    console.log('1');
    this.router.navigate(['/sessions/signin'], {
      queryParams: {
        returnUrl: this.deviceService.isMobile() ? '/phone' : url,
      },
    });
    return false;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const currentUser = this.authenticationService.currentUser;
    if (currentUser) {
      return true;
    }

    this.logger.debug('childRoute -> Yêu cầu user đăng nhập!');
    let url = state.url;
    if (url.includes('fbclid'))
      url = url.slice(0, state.url.indexOf('fbclid') - 1);
    this.router.navigate(['/sessions/signin'], {
      queryParams: {
        returnUrl: this.deviceService.isMobile() ? '/phone' : url,
      },
    });
    return false;
  }
}
